import React from 'react';
import { Empty, Flex, Typography } from 'antd';

const { Text } = Typography;

const WSEmpty = ({ description }: { description?: string }) => (
  <Flex style={{ height: '100%' }} justify={'center'} align={'center'}>
    <Empty description={<Text type="secondary">{description}</Text>} />
  </Flex>
);

export default WSEmpty;
